module.exports = __webpack_public_path__ + "images/patterns/pattern_bg_dot_yellow_d1ed72cbbc16efa619a56fe38c3896d2.jpg";